import { render, staticRenderFns } from "./RequestAutoAssignItem.vue?vue&type=template&id=8a644bae&"
import script from "./RequestAutoAssignItem.vue?vue&type=script&lang=js&"
export * from "./RequestAutoAssignItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestAutoAssignItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QCheckbox,QBtn,QTooltip,QBadge} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QCheckbox,QBtn,QTooltip,QBadge}, component.options.components || {})
